/* eslint-disable camelcase */
import { keysToCamelCase } from '@hotjar/insights-common/lib/convert-string';
import type { ProductDto } from './dto';
import type { ProductCatalog } from './model';

export function mapProductCatalogDtoToModel(products: ProductDto[]): ProductCatalog {
  return products.map(({ plans, product_id, product_name }) => ({
    name: product_name.toLowerCase(),
    id: product_id,
    plans: plans.map(({ allowances, plan_id, plan_name }, index) => ({
      id: plan_id,
      name: plan_name.toLowerCase(),
      // TODO: for now we get this from the array index, but we should ideally get this from the backend to make it safer in terms of changing order from under us without warning
      planTier: index,
      allowances: allowances.map((allowance) => keysToCamelCase(allowance)),
    })),
  }));
}
